import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const ROLES = {
	FUNMIYO_ADMIN: "ROLE_FUNMIYO_ADMIN",
	FUNMATH_ADMIN: "ROLE_FUNMATH_ADMIN",
	FUNMIYO_EMPLOYEE: "ROLE_FUNMIYO_EMPLOYEE",
	SCHOOL_ADMIN: "ROLE_SCHOOL_ADMIN",
	SCHOOL_TEACHER: "ROLE_SCHOOL_TEACHER",
	VIDEO_EDITOR: "ROLE_VIDEO_EDITOR",
};
